import React from 'react';

export default ({ field, form, children }) => {
  const error = form.errors[field.name];
  return (
    <>
      <select id={field.name} {...field}>
        { children }
      </select>
      {form.submitCount > 0 && error && <span className="form-control__error">{ error }</span>}
    </>
  );
};
